export default "__VITE_ASSET__4e4275b4__"